import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  // constructor(private translate: TranslateService) {
  //   this.initializeLanguage();
  // }

  // initializeLanguage() {
  //   let language = 'th';//localStorage.getItem('language') || 'en';
  //   this.translate.setDefaultLang(language);
  //   this.translate.use(language);
  // }

}
